import { CSSProperties, useState } from 'react';
import { IVirtualMachine } from '@vivli/features/virtual-machine/infrastructure/interface';
import { ButtonView } from '@vivli/shared/views';
import { Color } from '@vivli/shared/theme';

//The option labels carry the full data request title, which can run past 200 characters, and a select
//sizes itself to its widest option. Cap the container so the modal can't grow past the viewport and
//push the centered Submit button off-screen. (DEV-743)
const containerStyle: CSSProperties = {
    backgroundColor: Color.VIVLI_DARK_BLUE,
    color: 'white',
    borderRadius: '15px',
    padding: '20px',
    maxWidth: 'min(760px, calc(100vw - 60px))',
    boxSizing: 'border-box'
};

const buttonContainerStyle: CSSProperties = {
    display: 'flex',
    paddingTop: '25px',
    justifyContent: 'center',
    alignItems: 'center'
};

//width/maxWidth make the closed control clip a long label with an ellipsis rather than stretching the
//modal; the open dropdown list is browser-rendered and still shows each option in full. (DEV-743)
const selectStyle: CSSProperties = {
    padding: '10px',
    borderRadius: '10px',
    width: '100%',
    maxWidth: '100%',
    textOverflow: 'ellipsis'
};

interface SelectVirtualMachineModalComponentProps {
    virtualMachines: IVirtualMachine[];
    onVmSelected: (vm: IVirtualMachine) => void;
}

export const SelectVirtualMachineModalComponent = ({ virtualMachines, onVmSelected }: SelectVirtualMachineModalComponentProps) => {
    const [selectedVm, setSelectedVm] = useState<IVirtualMachine>(null);

    const handleOnChange = (e) => {
        const vm = virtualMachines.find((vm) => vm.id === e.target.value);
        setSelectedVm(vm);
    };

    return (
        <div style={containerStyle}>
            <select onChange={handleOnChange} style={selectStyle}>
                <option value={null}>- Select a Request -</option>

                {virtualMachines?.map((vm) => (
                    <option value={vm.id} key={vm.id}>{`${vm.dataRequestDoi} - ${vm.dataRequestTitle}`}</option>
                ))}
            </select>
            <div style={buttonContainerStyle}>
                <ButtonView onClick={() => selectedVm && onVmSelected(selectedVm)}>Submit</ButtonView>
            </div>
        </div>
    );
};
